var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProofMissingWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.866 2.4c-.38-.66-1.352-.66-1.732 0L1.268 12.2c-.38.66.095 1.485.866 1.485h11.732c.771 0 1.246-.825.866-1.485L8.866 2.4z",
    fill: "#FCC539"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.2a.6.6 0 0 0-.6.6v2.4a.6.6 0 1 0 1.2 0V6.8A.6.6 0 0 0 8 6.2zm0 5.2a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4z",
    fill: "#2D3245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProofMissingWarning);
export default __webpack_public_path__ + "static/media/proof-missing-warning.c6e96f090bfdf1482b6a55dd832e7ead.svg";
export { ForwardRef as ReactComponent };